import React, { useState } from 'react';
import { createKindBadge } from '../styles/registryStyles';
import IconButton from '@mui/material/IconButton';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

const EntryChildren = ({ selected, children, childrenLoading, modulesRef, theme, styles, kinds, onChildClick, onDeleteChild }) => {
  const [pending, setPending] = useState(null);
  const [deleting, setDeleting] = useState(false);

  if (!children || children.length === 0) {
    return null;
  }

  const handleConfirm = async () => {
    if (!pending) return;
    setDeleting(true);
    try {
      await onDeleteChild(pending.id);
      setPending(null);
    } catch (err) {
      console.error('Ошибка удаления:', err);
    } finally {
      setDeleting(false);
    }
  };

  return (
    <>
      <div ref={modulesRef} style={{ marginTop: 12, paddingTop: 12, borderTop: `1px dashed ${theme.toolbar.buttonBorder}` }}>
        <div style={{ fontWeight: 700, marginBottom: 8, color: theme.toolbar.text }}>
          Дочерние записи ({childrenLoading ? '…' : children.length})
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {children.map((child) => {
            const kindBadge = createKindBadge(child.kind_slug, kinds, theme);
            const kindName = kinds?.find(k => k.slug === child.kind_slug)?.name || child.kind_slug || 'Запись';
            const tagNames = (child.tags || []).map(t => t.name || t).filter(Boolean);
            return (
              <div
                key={child.id}
                style={{
                  ...styles.moduleCard,
                  cursor: 'pointer',
                  position: 'relative',
                  transition: 'background-color 0.15s ease, border-color 0.15s ease'
                }}
                onClick={() => onChildClick(child)}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = theme.name === 'light' ? '#e2e8f0' : '#2d3748';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = theme.name === 'dark' ? '#1a1f2e' : '#f8fafc';
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 2, paddingRight: 28 }}>
                  {child.kind_slug && <span style={kindBadge}>{kindName}</span>}
                  <div style={{ fontWeight: 600, color: theme.toolbar.text }}>{child.name}</div>
                  <div style={{ fontSize: 11, opacity: 0.6 }}>({child.code})</div>
                </div>
                {child.description && (
                  <div style={{ fontSize: 12, opacity: 0.8 }}>{child.description}</div>
                )}
                {tagNames.length > 0 && (
                  <div style={{ fontSize: 11, opacity: 0.7 }}>Теги: {tagNames.join(', ')}</div>
                )}
                {onDeleteChild && (
                  <IconButton
                    size="small"
                    title="Удалить"
                    onClick={(e) => { e.stopPropagation(); setPending({ id: child.id, name: child.name }); }}
                    style={{ position: 'absolute', top: 4, right: 4, color: '#ef4444' }}
                  >
                    <DeleteOutlineIcon fontSize="small" />
                  </IconButton>
                )}
              </div>
            );
          })}
        </div>
      </div>

      {pending && (
        <Dialog open onClose={() => !deleting && setPending(null)}>
          <DialogTitle>Удалить запись?</DialogTitle>
          <DialogContent>
            <DialogContentText>«{pending.name}» будет удалена навсегда.</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setPending(null)} disabled={deleting}>Отмена</Button>
            <Button onClick={handleConfirm} color="error" disabled={deleting} autoFocus>
              {deleting ? 'Удаление…' : 'Удалить'}
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};

export default EntryChildren;
